import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class SiteService {

  uri = '';
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.uri = this.appConfigService.apiBaseUrl;
  }

  GetSites() {
    return this.http.post<any>(this.uri + '/Site', { });
  }

  GetSitesByName(sitename) {
    return this.http.post<any>(this.uri + '/Site/GetSitesByName', { sitename: sitename });
  }

  GetSiteInfo(siteid) {
    return this.http.post<any>(this.uri + '/Site/GetSiteInfo', { siteid: siteid });
  }

  GetSiteHistory(siteid) {
    return this.http.post<any>(this.uri + '/Site/GetSiteHistory', { siteid: siteid });
  }

  GetSiteRecomendation(siteid) {
    return this.http.post<any>(this.uri + '/Site/GetSiteRecomendations', { siteid: siteid });
    // return this.http.post<any>(this.uri + '/Site/GetSiteRecomendations', { siteid: 1323 });
  }

  GetPunch(siteid) {
    return this.http.post<any>(this.uri + '/Punch', { serviceid: siteid });
    // return this.http.post<any>(this.uri + '/Punch', { serviceid: 2786 });
  }

  GetFaulDetection(siteid) {
    return this.http.post<any>(this.uri + '/Site/GetSiteFaultDet', { siteid: siteid });
    // return this.http.post<any>(this.uri + '/Site/GetSiteFaultDet', { siteid: 3066 });
  }

  InsertPunchItem(data) {
    return this.http.post<any>(this.uri + '/Punch/InsertPunch', data);
  }
}
